'use client';

import Script from 'next/script';
import { FC } from 'react';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import {
  getOrganizationStructuredData,
  getSoftwareApplicationStructuredData,
  getWebSiteStructuredData,
  renderStructuredData,
} from '@/utils/structured-data';

// All sections statically imported so they server-render at their true height.
// Previously Certification + GoToMarket were next/dynamic with a fixed 420px
// skeleton; the client-side swap to real content caused two layout-shift
// "bounces" on load (one per lazy section).
import GrowSection from './components/GrowSection';
import Introduce from './components/Introduce';
import Certification from './components/Certification';
import GoToMarket from './components/GoToMarket';

const HomePage: FC = () => (
  <>
    <ErrorBoundary
      fallback={
        <div className='bg-white pt-6 tablet:pt-11'>
          <div className='container-fluid px-4 md:px-7.5 text-center py-20'>
            <h1 className='text-4xl font-medium text-black mb-4'>Welcome to MarketBetter.ai</h1>
            <p className='text-xl text-slate-600'>AI-powered lead conversion platform</p>
          </div>
        </div>
      }
    >
      <Introduce />
    </ErrorBoundary>

    <ErrorBoundary
      fallback={
        <div className='bg-white py-20 text-center'>
          <h2 className='text-3xl font-medium text-black mb-4'>Customer Success Stories</h2>
          <p className='text-slate-600'>Our testimonials are temporarily unavailable.</p>
        </div>
      }
    >
      <GrowSection />
    </ErrorBoundary>

    <ErrorBoundary>
      <Certification />
    </ErrorBoundary>

    <ErrorBoundary>
      <GoToMarket />
    </ErrorBoundary>

    {/* Structured Data for SEO */}
    <Script
      id='organization-structured-data'
      type='application/ld+json'
      dangerouslySetInnerHTML={renderStructuredData(getOrganizationStructuredData())}
    />
    <Script
      id='software-application-structured-data'
      type='application/ld+json'
      dangerouslySetInnerHTML={renderStructuredData(getSoftwareApplicationStructuredData())}
    />
    <Script
      id='website-structured-data'
      type='application/ld+json'
      dangerouslySetInnerHTML={renderStructuredData(getWebSiteStructuredData())}
    />
  </>
);

export default HomePage;
